import React from 'react';
import { Button } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { nocModeSelector } from '@store/noc/base/selectors';
import { loadingSelector as trendsLoadingSelector } from '@store/noc/trendsData/selectors';
import { loadingSelector as filtersLoadingSelector } from '@store/noc/filtersData/selectors';
import { NOC_MODE_TRENDS } from '@utils/constants';
import { fetchData as trendsFetchData } from '@store/noc/trendsData/actions';
import { fetchData as filtersFetchData } from '@store/noc/filtersData/actions';
import {
  tableDataSelector,
  trendsTotalSelector,
  warmingUpFiltersSelector as trendsWarmupSelector,
} from '../MetricTable/TrendsTable/utils';
import { warmingUpFiltersSelector as filtersWarmupSelector } from '../MetricTable/FilterTable/utils';

const WARMUP_MESSAGE = 'Filter Warmup in Progress';
const WARN_TYPE = 'warning';
const ERROR_TYPE = 'error';
const ERROR_MESSAGE = 'Failed to fetch data';
const NO_DATA_MESSAGE = 'No data is available';

const StyledAlert = styled.div`
  font-weight: 600;
`;

const AlertWrapper = styled.div`
  display: flex;
  margin-right: 100px;
  border-radius: 3px;
  padding: 0 10px;
  color: #000;
  background-color: #fff5da;
  border: 1px solid #ffd861;
  justify-content: center;
  align-items: center;
`;

const RetryButton = styled(Button)`
  padding-right: 0;
  font-weight: 600;
`;

function Wrapper() {
  const mode = useSelector(nocModeSelector);
  const totalFilters = useSelector(trendsTotalSelector);
  const dataFilters = useSelector(tableDataSelector);
  let noDataFlag = false;
  if (mode === NOC_MODE_TRENDS) {
    if (totalFilters.length > 0 && dataFilters.data.length === 0) {
      noDataFlag = true;
    } else {
      noDataFlag = false;
    }
  }
  const warmupSelector = mode === NOC_MODE_TRENDS ? trendsWarmupSelector : filtersWarmupSelector;
  const loadingSelector = mode === NOC_MODE_TRENDS ? trendsLoadingSelector : filtersLoadingSelector;
  const fetchData = mode === NOC_MODE_TRENDS ? trendsFetchData : filtersFetchData;
  return (
    <Notifier
      warmupSelector={warmupSelector}
      loadingSelector={loadingSelector}
      noDataFlag={noDataFlag}
      fetchData={fetchData}
    />
  );
}

function Notifier({ warmupSelector, noDataFlag, loadingSelector, fetchData }) {
  const dispatch = useDispatch();
  const warmingUpFilters: any[] = useSelector(warmupSelector);
  const reqState: any = useSelector(loadingSelector);
  const handleRetry = () => dispatch(fetchData());

  if (warmingUpFilters.length > 0) {
    return (
      <AlertWrapper>
        <StyledAlert type={WARN_TYPE} />
        {WARMUP_MESSAGE}
      </AlertWrapper>
    );
  }

  if (noDataFlag) {
    return (
      <AlertWrapper>
        <StyledAlert type={WARN_TYPE} />
        {NO_DATA_MESSAGE}
      </AlertWrapper>
    );
  }

  if (reqState.errorCode) {
    return (
      <AlertWrapper>
        <StyledAlert type={ERROR_TYPE}>{ERROR_MESSAGE}</StyledAlert>
        <RetryButton type="link" size="small" onClick={handleRetry}>
          Retry
        </RetryButton>
      </AlertWrapper>
    );
  }

  return null;
}

export default Wrapper;
